<template>
  <div>
    <v-row  no-gutters>
      <v-col v-for="component in componentProcessingClusters" :key="component.name" cols="12">
        <component v-bind:is="component"></component>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ProcessingCluster',
  mounted () {
    const req = require.context('@/components/categoriesComponents/processing_cluster', true, /\.(vue)$/i)
    const allComponentsFiles = req.keys().map(key => {
      const name = key.match(/\w+/)[0]
      return Vue.component(name, req(key))
    })
    for (let i = 0; i < allComponentsFiles.length; i++) {
      if (allComponentsFiles[i].default === this.componentProcessingClusters[i]) {
        continue
      }
      this.componentProcessingClusters.push(allComponentsFiles[i].default)
    }
  },
  data () {
    return {
      componentProcessingClusters: []
    }
  }
}
</script>
